import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
// enums
import ESeverityLevel from '@/cms/enums/ESeverityLevel';
// types
import TValidations from '@/cms/types/TValidations';


type TRMDRTextBox = {

    name: string;
    title?: string;
    rmdrRef?: any;
    
    value?: string;
    placeholder?: string;

    errors?: TValidations[]|null;
    isAutoFocus?: boolean;

    type?: string;

    onValueChanged?: (name:string, value?:string|null) => void;

    className?: string;
    inputClassName?: string;
    disabled?: boolean;

}


const RMDRTextBox = ( props:TRMDRTextBox ) => {
    
    const [validation, setValidation] = useState<any>(null);

    useEffect(
        () => {
            let __value = props.errors?.find((item:any) => item.propertyName === props.name);

            if ( __value ) { 
                let className = "";

                if (__value.severity === ESeverityLevel.ERROR) className = "tw-bg-red-100 tw-rounded-t-none tw-text-red-700 tw-p-2 tw-rounded tw-text-sm"
                else if (__value.severity === ESeverityLevel.WARNING) className = "tw-bg-orange-100 tw-rounded-t-none tw-text-orange-700 tw-p-2 tw-rounded tw-text-sm"
                else if (__value.severity === ESeverityLevel.INFO) className = "tw-bg-blue-100 tw-rounded-t-none tw-text-blue-700 tw-p-2 tw-rounded tw-text-sm"
                
                setValidation({ ...__value, className }); 
            }

            if ( !__value && validation ) setValidation(null);
        }, [ props.errors ]
    )

    return (
        <div className={props.className}>
            {
                props.title && (<label>{props.title}</label>)
            }
            <input
                ref={props.rmdrRef}
                name={props.name}
                defaultValue={props.value}
                placeholder={props.placeholder}
                type={props.type}
                disabled={props.disabled}
                autoFocus={props.isAutoFocus}
                className={props.inputClassName}
            />
            {
                validation && (
                    <div className={validation.className}>{validation.errorMessage}</div>
                )
            }
        </div>
    )
}

RMDRTextBox.defaultProps = {
    title: undefined,
    rmdrRef: undefined,
    
    value: "",
    placeholder: "",

    errors: undefined,
    isAutoFocus: false,

    type: "text",

    onValueChanged: null,

    className: undefined,
    inputClassName: undefined,
    disabled: false,
}

export default RMDRTextBox;
export type {
    TRMDRTextBox
};
